import { Box, CircularProgress, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

interface LoadingFallbackProps {
    /** When true (default), fills the entire viewport. When false, fills its parent container. */
    fullPage?: boolean
}

export default function LoadingFallback({ fullPage = true }: LoadingFallbackProps) {
    const { t } = useTranslation()

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                ...(fullPage ? { minHeight: '100vh' } : { flex: 1, minHeight: 0 }),
                p: 3,
            }}
            role="status"
            aria-live="polite"
            aria-label={t('common:loading')}
        >
            <CircularProgress size={48} sx={{ mb: 2 }} />
            <Typography
                variant="body1"
                sx={{
                    color: 'text.secondary',
                }}
            >
                {t('common:loading')}
            </Typography>
        </Box>
    )
}
